type DataLayerEvent = Record<string, string | number | boolean | undefined>;

declare global {
  interface Window {
    dataLayer: DataLayerEvent[];
  }
}

const pushToDataLayer = (event: DataLayerEvent) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};

// Generate a readable page title from path
const getPageTitleFromPath = (path: string): string => {
  const cleanPath = path.split('?')[0].replace(/^\//, '') || 'home';
  const segments = cleanPath.split('/').filter(Boolean);

  if (segments.length === 0) return 'Home';

  const routeMap: Record<string, string> = {
    servicios: 'Services',
    service: 'Service Details',
    profesional: 'Worker Profile',
    ingresar: 'Login',
    registro: 'Signup',
    'preguntas-frecuentes': 'FAQ',
    'sobre-nosotros': 'About',
    'my-proposals': 'My Proposals',
    'my-jobs': 'My Jobs',
    'payments-history': 'Payments History',
    'transactions-history': 'Transactions History',
    chat: 'Messages',
    settings: 'Settings',
    'my-profile': 'My Profile',
    'update-certifications': 'Update Certifications',
    'client-faq': 'Client FAQ',
    'provider-faq': 'Provider FAQ',
    'terminos-de-uso': 'Terms of Use',
    'politica-de-privacidad': 'Privacy Policy',
    'politica-de-mensajes': 'Text Message Policy',
    'verify-account': 'Verify Account',
    'reset-password': 'Reset Password',
    'update-worker': 'Update Worker Profile',
  };

  const firstSegment = segments[0];
  const baseTitle =
    routeMap[firstSegment] ||
    firstSegment.charAt(0).toUpperCase() + firstSegment.slice(1).replace(/-/g, ' ');

  if (segments.length > 1) {
    if (firstSegment === 'profesional') return baseTitle;
    return `${baseTitle} - ${segments[1]}`;
  }

  return baseTitle;
};

// Preserved for compatibility with existing calls.
export const initGA = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
  }
};

// Track page views (for SPA navigation)
export const trackPageView = (path: string, title?: string) => {
  if (typeof window === 'undefined') return;

  setTimeout(() => {
    const generatedTitle = getPageTitleFromPath(path);
    const currentDocTitle = document.title;
    const isDefaultTitle = currentDocTitle === 'Jandi' || currentDocTitle.trim() === '';
    const pageTitle = title || (!isDefaultTitle ? currentDocTitle : generatedTitle);

    pushToDataLayer({
      event: 'page_view',
      page_path: path,
      page_title: pageTitle,
      page_location: window.location.href,
    });
  }, 200);
};

// Track user actions (e.g., button clicks, form submissions)
export const trackUserAction = (
  action: string,
  params?: Record<string, string | number | boolean>
) => {
  pushToDataLayer({
    event: action,
    ...params,
  });
};
